<template>
  <div class="Integration">
    <div class="title-heading" style="margin: 10px 0 0 20px;"> <!-- heading -->
      <p>
        <i style="position: relative; top: 5px;margin-right: 5px;">
          <img src="@/assets/titleBlock/heading1.png" alt="">
        </i>
        <!-- 集成设置 -->
        {{ $t("message.title.IntegrationSetting") }}
        <i style="position: relative; top: 5px;margin-left: 5px;">
          <img src="@/assets/titleBlock/heading2.png" alt="">
        </i>
      </p>
    </div>
    <div class="integra">

      <div style="flex: 0 600px;">
        <el-button @click="getAdd" icon="el-icon-circle-plus-outline"> {{ $t("message.button.add") }} </el-button>
      </div>
      <div style="flex: 1;">

        <el-button type="primary" @click="submit" icon="el-icon-circle-check">{{ $t("message.button.submit")
          }}</el-button>
        <el-button @click="cancel" icon="el-icon-circle-close"> {{ $t("message.button.cancel") }}</el-button>
        <!--
        <el-button style="float: right; margin-right: 10px; margin-top: 10px" @click="cancel" v-if="editable">{{
          $t("message.button.cancel") }}</el-button>
        <el-button type="success" style="float: right; margin-right: 10px; margin-top: 10px" @click="onSubmit('form')"
          v-if="editable">{{ $t("message.button.save") }}</el-button> -->
      </div>
    </div>
    <div class="integra" v-if="getItem">
      <div v-for="(item, index) in list" :key="item.id" class="item">
        <!-- {{ 'NO.' + (index + 1) }} -->
        <div class="content">
          <integra-item :data="item" :change.sync="item.value" ref="item" @delete=deleteItem(index) />
        </div>
      </div>
    </div>

  </div>
</template>


<script>
import axios from "axios";
import IntegraItem from './integraItem.vue'
export default {
  data() {
    return {
      Num: 1,
      list: [],
      getItem: false
    }
  },
  mounted() {
  },
  components: {
    IntegraItem
  },
  methods: {

    deleteItem(e) {
      console.log(e);
      // if (this.list.length == 1) {
      //   return
      // }
      this.list.splice(e, 1);
      this.subData(this.list)
    },

    getAdd() {
      // this.Num ++
      this.list.push({
        "hostname": "",
        "password": "",
        "sysType": "zhibERP",
        "name": "",
        "checked": true
      })
    },
    getNotifications() {
      axios.get('/pmdm/admin/geIntegrationSettings')
        .then(res => {
          // this.list = [res.data.object];
          this.list = res.data.object.map((i, e) => {
            i.id = e;
            return i
          })
          this.getItem = true
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    submit() {
      // console.log(this.list);
      const arr = this.$refs.item.map(i => i.pushData());

      // const l = arr.map(i => i.pushData());
      // console.log(l);
      this.subData(arr);
    },
    subData(arr) {
      axios.post('/pmdm/admin/saveIntegrationSettings', arr)
        .then(res => {
          // console.log(response);
          this.$message({
            message: res.data.message,
            type: 'success'
          });
          // vm.editable = false;
          // this.old_form = this.deepClone(this.form);
        })
        .catch(function (error) {
          vm.getNotifications();
        });
    },
    cancel() { }

  },
  created() {
    this.getNotifications();
  }
};
</script>

<style scoped>
.integra {
  display: flex;
  flex-wrap: wrap;
  padding: 25px;
  padding-bottom: 0px;
}

.item {
  /* flex: 1; */
  width: 380px;
  padding: 15px 10px;
  margin: 10px;
  margin-left: 0px;
  box-sizing: border-box;
}

.content {
  padding: 15px;
  border: 1px solid #eee;
  border-radius: 3px;
}

.title-heading p {
  font-size: 18px;
  font-weight: 400;
  margin: 0;
}

.notifications {
  width: 100%;
  height: 800px;
  background: #fff;
  overflow: hidden;
}
</style>
